import React from 'react';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import PageMeta from '../components/common/PageMeta';
import FooterOne from '../layout/Footer/FooterOne';
// import CtaTwo from '../components/cta/CtaTwo';
import OpenJobs from '../components/career/OpenJobs';
import CareerPromo from '../components/career/CareerPromo';
import PageHeader from '../components/common/PageHeader';

const Career = () => {
  return (
    <Layout>
      {/* <PageMeta title="Career - Software &amp; IT Solutions HTML Template" /> */}
      <Navbar navDark/>
      <PageHeader
        title="Career"
        desc="Build your future with us! At Senertech, we value innovation, collaboration, and growth. Join our team to explore exciting opportunities, work with passionate professionals, and shape a rewarding career in a supportive and dynamic environment."
      />
      <OpenJobs />
      <CareerPromo />
      {/* <CtaTwo /> */}
      <FooterOne />
    </Layout>
  );
};

export default Career;
